import { Ye as u } from "./abstract-base-CzLmw6_x-Ds3dPjNU.js";
import { y as s, a as i } from "./lifecycle-decorators-CUsT9aHq-Dtp3uB6c.js";
import { k as S } from "./query-assigned-K46zQIzj-dGW7AjV_.js";
var d = Object.defineProperty, p = Object.getOwnPropertyDescriptor, n = (a, l, e, o) => {
  for (var t = o > 1 ? void 0 : o ? p(l, e) : l, r = a.length - 1, f; r >= 0; r--)
    (f = a[r]) && (t = (o ? f(l, e, t) : f(t)) || t);
  return o && t && d(l, e, t), t;
};
const h = ({ clean: a } = { clean: !1 }) => function(l) {
  let e = class extends l {
    /**
     * Removes any whitespace from the default slot.
     *
     * Default slots can see whitespace or new line characters as node slotted in, which can cause presentational issues when there's fallback content in the slot's position.
     *
     * This issue is commonly seen in AEM applications but can be a result of any templating syntax that doesn't trim whitespace from HTML nodes the whole way.
     */
    cleanDefaultSlot() {
      this.defaultSlotNodes.forEach((o) => {
        var t;
        !o.slot && !((t = o.textContent) != null && t.trim()) && o.remove();
      });
    }
    /** Sets internal state for slot text and existance of slot content */
    setDefaultSlotText() {
      this.defaultSlotText = this.getDefaultSlotText(), a && this.cleanDefaultSlot();
    }
    /** Grabs slotted text and sets the state defaultSlotText property. */
    getDefaultSlotText() {
      if (this.defaultSlotNodes.length > 0)
        return this.defaultSlotNodes.map((o) => {
          var t, r;
          return (r = (t = o.textContent) == null ? void 0 : t.trim()) != null ? r : "";
        }).join("");
    }
    postrenderSetDefaultSlotText() {
      this.setDefaultSlotText();
    }
  };
  return n([
    u()
  ], e.prototype, "defaultSlotText", 2), n([
    S({ flatten: !0 })
  ], e.prototype, "defaultSlotNodes", 2), n([
    s
  ], e.prototype, "postrenderSetDefaultSlotText", 1), e = n([
    i("TracksDefaultSlot")
  ], e), e;
};
export {
  h as m
};
